import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isValid, setIsValid] = useState<boolean | null>(null);

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const jwtTime = localStorage.getItem('jwtTime');
    
    if (!jwt || !jwtTime) {
      setIsValid(false);
      return;
    }

    const tokenTime = new Date(jwtTime);
    const expiryTime = new Date(tokenTime.getTime() + 24 * 60 * 60 * 1000); // +24 hours
    const now = new Date();
    
    if (now >= expiryTime) {
      // Token expired, clear it
      localStorage.removeItem('jwt');
      localStorage.removeItem('jwtTime');
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, []);

  if (isValid === null) {
    // Still checking, you could show a loading spinner here
    return null;
  }

  return isValid ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;